var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loaded
    ? _c(
        "div",
        {
          class: [
            "custom-dropdown",
            "element",
            { "light-mode": _vm.$route.meta.headerColor === "light" }
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "selected element",
              on: { click: _vm.toggleDropdown }
            },
            [
              _c("img", {
                staticClass: "flag element",
                attrs: {
                  src: require(`@/drc/assets/images/flags/${_vm.selectedLanguage.short}.svg`),
                  alt: _vm.selectedLanguage.name
                }
              }),
              _c("span", { staticClass: "language-name element" }, [
                _vm._v(_vm._s(_vm.selectedLanguage.name))
              ])
            ]
          ),
          _vm.dropdownOpen
            ? _c(
                "ul",
                { staticClass: "dropdown-list element" },
                _vm._l(_vm.languages, function(language, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "element",
                      on: {
                        click: function($event) {
                          return _vm.selectLanguage(language)
                        }
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "flag element",
                        attrs: {
                          src: require(`@/drc/assets/images/flags/${language.short}.svg`),
                          alt: language.name
                        }
                      }),
                      _c("span", { staticClass: "selected-name element" }, [
                        _vm._v(_vm._s(language.name))
                      ])
                    ]
                  )
                }),
                0
              )
            : _vm._e()
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }